// @flow

import React from 'react';
import type { Element } from 'react';
import styled from 'styled-components';

import BaseComponent from '../lib/base-component';
import { SectionChild } from '../components/section';

type Props = {
  children: Element<*> | string,
  bold?: boolean,
  italic?: boolean,
  align?: 'left' | 'center' | 'right',
  paragraph?: boolean,
  _parent?: ?string
};

const VALID_ALIGN = ['left', 'center', 'right'];

const Span = styled.span`
  word-break: break-word;
  ${({ bold }) => bold && 'font-family: "Proxima Nova Bold"; '}
  ${({ italic }) => italic && 'font-style: italic;'}
  ${({ align }) => align && VALID_ALIGN.includes(align) && `text-align: ${align}`}
`;

const Div = Span.withComponent('div');

const Para = Span.withComponent('p');

export default class Text extends BaseComponent<Props> {
  static _type = 'Text';
  _type = 'Text';

  render() {
    const { children, paragraph, bold, italic, align = 'left' } = this.props;

    let Type = Div;

    if (paragraph) {
      Type = Para;
    }

    if (this.parent === 'Text') {
      Type = Span;
    }

    return (
      <SectionChild type="text">
        <Type bold={bold} italic={italic} align={align}>
          {children}
        </Type>
      </SectionChild>
    );
  }
}



// WEBPACK FOOTER //
// ./src/fitbit-components/text.js